import React from 'react'

const WorkLife = () => {
    const worklife = [
        {
            id:1,
            img:"https://www.datamatics.com/hubfs/Media-Streaming.svg",
            para:"Media Streaming",
        },
        {
            id:2,
            img:"https://www.datamatics.com/hubfs/Digital-Content-Distribution.svg",
            para:"Digital Content Distribution",
        },
        {
            id:3,
            img:"https://www.datamatics.com/hubfs/mCommerce.svg",
            para:"mCommerce",
        },
        {
            id:4,
            img:"https://www.datamatics.com/hubfs/Mobile-Healthcare-1.svg",
            para:"Mobile Healthcare",
        },
        {
            id:5,
            img:"https://www.datamatics.com/hubfs/Workflow.svg",
            para:"Workflow & Asset Management",
        },
        {
            id:6,
            img:"https://www.datamatics.com/hubfs/game.svg",
            para:"Mobile Games",
        },
        {
            id:7,
            img:"https://www.datamatics.com/hubfs/Fleet-Management.svg",
            para:"Fleet Management",
        },
    ]
    return (
        <>
            <section className="work-life-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12" style={{ marginTop: "30px" }}>
                            <div className="section-title">
                                <h2 className="text-center heading2">Application Development Solutions</h2>
                                <div className="bar"></div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        {worklife.map((workcard)=>{
                            return  <div className="col-lg-4 col-md-4 col-6" key={workcard.id}>
                                        <div className="application-box">
                                            <div className="app-img-dv">
                                                <img src={workcard.img} alt="" className="img-fluid" loading="lazy"/>
                                            </div>
                                            <div className="app-box-para">
                                                <p>{workcard.para}</p>
                                            </div>
                                        </div>
                                    </div>
                        })}
                    </div>
                </div>
            </section>
        </>
    )
}

export default WorkLife